import React, { useContext, useEffect, useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import { AuthContext } from '../../../component/context/AuthContext';
import axios from 'axios';
import { GET_EMP_BY_ID, HOST } from '../../../component/config/Constant';
import * as CONST from "../../../component/config/Constant";
import { toast } from 'react-toastify';
import DivSpinner from '../../../component/utilities/Spinner';
import moment from 'moment';
import Swal from 'sweetalert2';
import '../employee/employee-details.css';

function AccountClearance({ closeAccountClearanceModal, resignationData }) {
  const [authUserData] = useContext(AuthContext);
  const [show] = useState(true);
  const [loading, setLoading] = useState(false);
  const [empDetails, setEmpDetails] = useState(null);
  const [resignationDetails, setResignationDetails] = useState(null);
  const [approvalComment, setApprovalComment] = useState("");
  const [processing, setProcessing] = useState(false);
  const [errors, setErrors] = useState({});
 
  let isToken = "";
  let user_id = "";
  let department_id = "";

  if (authUserData && authUserData[0]) {
    isToken = authUserData[0].token || "";
    user_id = authUserData[0].user_id || "";
    department_id = authUserData[0].department_id || "";
  }
  // 1. Determine the current step and status from fresh data if available, else props
  const activeStep =
    resignationDetails?.current_step || resignationData?.current_step;
  const activeStatus =
    resignationDetails?.final_status || resignationData?.final_status;

  // 2. Refined Permission Logic
  const isPending = activeStatus === "Pending";

  // Check if user is Accounts (Dept 9) and it's the Accounts step (4)
  const isAccountsActing = department_id == 9 && activeStep === 4;

  // 3. Final Boolean for visibility
  // The hub shows if it's pending AND (the user is HR in an HR step OR the user is Accounts in an Accounts step)
  const showActionHub = isPending && isAccountsActing;
  const fetchDetails = async () => {
    setLoading(true);
    try {
      const empRes = await axios.post(
        GET_EMP_BY_ID,
        {
          id: user_id,
          user_id: resignationData.user_id,
        },
        {
          headers: { Authorization: `Bearer ${isToken}` },
        },
      );
      if (empRes.data.status === "success") setEmpDetails(empRes.data.data);

      const detailsRes = await axios.get(
        `${CONST.RESIGNATION_DETAILS}${resignationData.id}`,
        {
          headers: { Authorization: `Bearer ${isToken}` },
        },
      );
      if (detailsRes.data.status === "success")
        setResignationDetails(detailsRes.data.data);
    } catch (error) {
      toast.error("Error fetching details.");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchDetails();
  }, []);

   const handleAction = async (action) => {
    setErrors({});
    const validationErrors = {};
 
    // 1. Comment Validation (Inline)
    if (!approvalComment || !approvalComment.trim()) {
      validationErrors.approvalComment =
        "Please provide a final review remark.";
    }
 
    // If validation fails, update state and stop
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
 
    // 2. Step Validation (System-level error, toast is acceptable here)
    const pendingStep = resignationDetails?.workflows?.find(
      (w) => w.status === "Pending",
    );
    if (!pendingStep) {
      toast.error("No pending step found for this resignation.");
      return;
    }
 
    Swal.fire({
      title: `Are you sure?`,
      text: `Do you want to ${action === "Approved" ? "approve" : "reject"} this resignation?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: `Yes, ${action}!`,
      confirmButtonColor: action === "Approved" ? "#0d6efd" : "#dc3545",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setProcessing(true);
        try {
          const response = await axios.post(
            CONST.RESIGNATION_PROCESS,
            {
              resignation_id: resignationData.id,
              step_number: pendingStep.step_number,
              action: action,
              comment: approvalComment,
            },
            {
              headers: { Authorization: `Bearer ${isToken}` },
            },
          );
 
          if (response.data.status === "success") {
            toast.success(`Resignation ${action} successfully.`);
            setApprovalComment("");
            fetchDetails(); // Refresh view
            closeAccountClearanceModal();
          } else {
            toast.error(response.data.message);
          }
        } catch (error) {
          toast.error(error.response?.data?.message || "Server error during processing.");
        } finally {
          setProcessing(false);
        }
      }
    });
  };
const workflows = [...(resignationDetails?.workflows || [])].sort(
  (a, b) => a.step_number - b.step_number
);
const totalSteps = workflows.length;
// find active step index (Pending OR last Approved)
let activeIndex = workflows.findIndex((w) => w.status === "Pending");
if (activeIndex === -1) {
  activeIndex = workflows.length - 1; // all completed
}

// calculate width per step
const stepWidth = 100 / (totalSteps - 1);

// final progress width
const lineWidth = activeIndex * stepWidth;
  return (
    <Modal
      show={show}
      onHide={() => closeAccountClearanceModal("hide")}
      backdrop="static"
      centered
      fullscreen={true}
      enforceFocus={false}
      contentClassName="border-0 rounded-0"
    >
      <Modal.Header closeButton className="bg-white border-bottom px-4 py-3">
        <Modal.Title className="fw-bold text-dark d-flex align-items-center">
          <div className="bg-primary-subtle p-2 rounded-3 me-3 mr-3 text-primary">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z"></path>
              <path d="M18 8h-2.1l-2.6 7h1.7c.5 0 1 .3 1.2.7l1.7 4.1c.2.5.1 1.1-.4 1.3-.5.2-1.1.1-1.3-.4L14.7 17H9.3l-1.6 3.7c-.2.5-.8.7-1.3.4-.5-.2-.7-.8-.4-1.3l1.7-4.1c.2-.4.7-.7 1.2-.7h1.7l-2.6-7H6c-1.1 0-2-.9-2-2s.9-2 2-2h12c1.1 0 2 .9 2 2s-.9 2-2 2z"></path>
            </svg>
          </div>
          Review Resignation Case: {resignationData?.user?.first_name}{" "}
          {resignationData?.user?.last_name}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-light p-0">
        {loading && (
          <div className="text-center py-5">
            <DivSpinner size="lg" color="primary" />
          </div>
        )}

        {!loading && (
          <div className="container-fluid p-4">
            <div className="row g-4">
              {/* Left Column: Profile Snapshot */}
              <div className="col-lg-4">
                <div className="card h-auto" style={{ borderRadius: 14, border: '1px solid #e2e8f0' }}>
                  {empDetails ? (
                    <div style={{ padding: '20px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 16 }}>
                        <div style={{ width: 56, height: 56, minWidth: 56, borderRadius: '50%', overflow: 'hidden', background: '#0f2847', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#7db3ff', fontWeight: 700, fontSize: '1rem' }}>
                          {empDetails.profile_photo_path ? (
                            <img src={HOST + empDetails.profile_photo_path} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                          ) : (<>{empDetails.first_name?.[0]}{empDetails.last_name?.[0]}</>)}
                        </div>
                        <div>
                          <div style={{ fontWeight: 700, fontSize: '1rem', color: '#0a1628' }}>{empDetails.first_name} {empDetails.last_name}</div>
                          <div style={{ fontSize: '0.78rem', color: '#64748b' }}>{empDetails.designation?.name} | {empDetails.department?.name}</div>
                          <span style={{ background: '#f0f5ff', color: '#1167e8', padding: '2px 10px', borderRadius: 12, fontSize: '0.7rem', fontWeight: 600 }}>EMP-{empDetails.id}</span>
                        </div>
                      </div>
                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', borderTop: '1px solid #e2e8f0', borderBottom: '1px solid #e2e8f0', padding: '14px 0' }}>
                        <div>
                          <div style={{ fontSize: '0.68rem', color: '#64748b', fontWeight: 600, textTransform: 'uppercase', marginBottom: 2 }}>Applied On</div>
                          <div style={{ fontSize: '0.85rem', fontWeight: 600, color: '#0a1628' }}>{moment(resignationData?.applied_date).format("DD MMM YYYY")}</div>
                        </div>
                        <div>
                          <div style={{ fontSize: '0.68rem', color: '#64748b', fontWeight: 600, textTransform: 'uppercase', marginBottom: 2 }}>Target Release</div>
                          <div style={{ fontSize: '0.85rem', fontWeight: 600, color: resignationData?.release_date ? '#059669' : '#d97706' }}>{resignationData?.release_date ? moment(resignationData.release_date).format("DD MMM YYYY") : (resignationData?.final_status || "Not Set")}</div>
                        </div>
                      </div>
                      <div style={{ paddingTop: 14 }}>
                        <div style={{ fontSize: '0.68rem', color: '#64748b', fontWeight: 600, textTransform: 'uppercase', marginBottom: 6 }}>Reason</div>
                        <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 8, padding: '12px 14px', fontSize: '0.85rem', color: '#334155', lineHeight: 1.6 }}
                          dangerouslySetInnerHTML={{ __html: resignationData?.reason }} />
                      </div>
                    </div>
                  ) : (
                    <div className="text-center p-4">
                      <DivSpinner size="sm" color="primary" />
                    </div>
                  )}
                </div>
              </div>

           {/* Right Column: Decisions & History */}
                        <div className="col-lg-8">
                          <div className="row g-4">
                            {/* Workflow Section */}
                            <div className="col-12 ">
                              <div className="card mt-3 border-2 shadow-sm rounded-4 p-4 bg-white">
                                <h5 className="fw-bold mb-4 d-flex align-items-center text-dark">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="me-3"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2.5"
                                  >
                                    <circle cx="12" cy="12" r="10" />
                                    <polyline points="12 8 12 12 14 14" />
                                  </svg>
          
                                  <span className="fw-bold text-dark ml-2">
                                    Submission Lifecycle
                                  </span>
                                </h5>
          
                               <div className="d-flex align-items-center w-100 mt-4">
                                  {workflows.map((w, idx) => (
                                    <React.Fragment key={w.id}>
                                      
                                      {/* STEP */}
                                      <div className="text-center d-flex flex-column align-items-center">
                                        
                                        {/* Circle */}
                                      <div className="d-flex align-items-center justify-content-center">
                                  <div
                                    className={`rounded-circle d-flex align-items-center justify-content-center shadow-sm border border-3 border-white ${
                                      w.status === "Approved"
                                        ? "bg-success text-white"
                                        : w.status === "Rejected"
                                          ? "bg-danger text-white"
                                          : w.status === "Pending"
                                            ? "bg-primary text-white"
                                            : "bg-white text-muted border-primary-subtle"
                                    }`}
                                    style={{ width: 36, height: 36, fontSize: '0.8rem', fontWeight: 800 }}
                                  >
                                    {w.status === "Approved"
                                      ? "✓"
                                      : w.status === "Rejected"
                                        ? "✗"
                                        : w.step_number}
                                  </div>
                                </div>
          
                              {/* Label */}
                              <div className="small fw-bold mt-2 text-dark text-uppercase" style={{ fontSize: '0.65rem' }}>
                                {w.step_name}
                              </div>
          
                              {/* Badge */}
                              {w.step_name !== "Applied" && (
                                <div
                                  className={`db-status-badge ${
                                    w.status === "Approved"
                                      ? "db-badge-success"
                                      : w.status === "Rejected"
                                        ? "db-badge-danger"
                                        : w.status === "Pending"
                                          ? "db-badge-warning"
                                          : "db-badge-light"
                                  }`}
                                  style={{ fontSize: "0.55rem" }}
                                >
                                  {w.status}
                                </div>
                              )}
                            </div>
          
                            {/* LINE BETWEEN STEPS */}
                            {idx !== workflows.length - 1 && (
                              <div
                                className="flex-grow-1 mx-1"
                                style={{
                                  height: 3,
                                  backgroundColor: "#0d6efd",
                                  alignSelf: "center",
                                  position: "relative",
                                  top: "-9px"  
                                }}
                                ></div>
                                    )}
          
                                  </React.Fragment>
                                ))}
                                </div>
          
                              </div>
                            </div>

                  {/* Approval Actions */}
                  {showActionHub && (
                    <div className="col-12">
                      <div className="card border-0 shadow-sm rounded-4 p-4 bg-white">
                        <div className="d-flex align-items-center mb-4">
                          <div className="bg-primary-subtle p-2 rounded-3 me-3 mr-3 text-primary">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                              <circle cx="8.5" cy="7" r="4"></circle>
                              <polyline points="17 11 19 13 23 9"></polyline>
                            </svg>
                          </div>
                          <h5 className="fw-bold mb-0 text-dark ls-1 text-uppercase small">
                            {activeStep === 4
                              ? "Accounts Clearance Hub"
                              : "Management Action Hub"}
                          </h5>
                        </div>

                        <div className="form-group mb-4">
                          <label className="form-label fw-bold small text-muted opacity-75">
                            FINAL REVIEW REMARK / FEEDBACK
                          </label>
                          <textarea
                            className={`form-control border-opacity-25 ${
                              errors.approvalComment ? "is-invalid" : ""
                            }`}
                            rows="4"
                            style={{ borderRadius: '1rem' }}
                            placeholder="Describe your assessment..."
                            value={approvalComment}
                            onChange={(e) => {
                              setApprovalComment(e.target.value);
                              // Clear error border as the user starts typing
                              if (errors.approvalComment) {
                                setErrors((prev) => ({
                                  ...prev,
                                  approvalComment: null,
                                }));
                              }
                            }}
                          ></textarea>
                          {/* Inline Error Message */}
                          {errors.approvalComment && (
                            <div className="invalid-feedback d-block ps-2">
                              {errors.approvalComment}
                            </div>
                          )}
                        </div>
 
                        <div className="d-flex justify-content-end gap-3">
                          <button
                            className="btn btn-outline-danger btn-lg px-4 rounded-3 fw-bold mr-2"
                            onClick={() => handleAction("Rejected")}
                            disabled={processing}
                          >
                            Reject Case
                          </button>
                          <button
                            className="btn btn-primary btn-lg px-4 rounded-3 fw-bold shadow-sm"
                            onClick={() => handleAction("Approved")}
                            disabled={processing}
                          >
                            {processing ? (
                              <>
                                <span className="spinner-border spinner-border-sm me-2 mr-2" role="status" aria-hidden="true"></span>
                                Processing...
                              </>
                            ) : "Confirm Approval"}
                          </button>
                        </div>
                      </div>
                    </div>
                  )}

                </div>
              </div>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default AccountClearance;
